import React, { Component } from "react";
//import ReactDOM from "react-dom";
//import classNames from "classnames";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import Swal from "sweetalert2";
//import { rgbToHex } from "@coreui/coreui/dist/js/coreui-utilities";
import Axios from "axios";
import { configuration } from "../appConfig";

var convert = require("xml-js");

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

export default class CustomerInformation extends Component {
  state = {
    selectedFile: "",
    customerInfo: {
      vinNumber: "",
      manufacturer: "",
      customerNumber: "",
      emailAddress: "",
      Name: "",
      model: "",
      street: "",
      color: "",
      regNo: "",
      customerCity: "",
      postalCode: "",
      abc: "",
    },
    vinfolderList: [],
    makeModel: [],
    Models: [],
  };
  getMakeModel = () => {
    Axios.get("makeModel.json").then((r) => {
      this.setState({ makeModel: r.data });
    });
  };
  componentDidMount() {
    this.getMakeModel();
    this.customerInfo();
    this.vinFolderList();
  }
  handleChange = (e) => {
    this.setState({
      customerInfo: {
        ...this.state.customerInfo,
        [e.target.name]: e.target.value,
      },
    });
  };
  customerInfo = async () => {
    //alert('No Partner Id selected! Please login.')

    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    if (partnerId) {
      const res = await Axios.get(
        configuration.getCustomerInfo +
          "?partnerId=" +
          partnerId +
          "&vin=" +
          vin.split("_")[0]
      );
      if (res.data.length) {
        this.setState({ customerInfo: res.data[0] });
      } else {
        let clr = {
          vinNumber: "",
          manufacturer: "",
          customerNumber: "",
          emailAddress: "",
          Name: "",
          model: "",
          street: "",
          color: "",
          regNo: "",
          customerCity: "",
          postalCode: "",
          abc: "",
        };
        this.setState({ customerInfo: clr });
      }
    } else {
      // this.props.history.push('/login');
      // alert('No Partner Id selected! Please login.')
    }
  };

  connectDAT = async () => {
    console.clear();
    var src = "Boolean";
    var dest = "String";
    var arr = [
      { type: ["INT", "Integer", "String"] },
      { type: ["Boolean", "String"] },
    ];

    var rop = arr.some((o) => o.type.includes(src) && o.type.includes(dest));

    var xml = "";

    var xmlhttp = new XMLHttpRequest();
    xmlhttp.open(
      "POST",
      "https://www.dat.de/myClaim/soap/v2/MyClaimExternalService",
      true
    );

    const dd = await Axios.get("/DAT/newOrder.xml");

    var options = {
      compact: true,
      ignoreComment: true,
      spaces: 4,
      trim: true,
    };

    var result = convert.xml2json(dd.data, options);
    var dl = JSON.parse(result);
    const dossier =
      dl["soap:Envelope"]["soap:Body"]["ns2:createOrUpdateContract"][
        "ns2:Dossier"
      ];
    dossier["ns2:Name"]["_text"] = this.state.selectedFile;
    dossier["vxs:Vehicle"]["vxs:VehicleIdentNumber"][
      "_text"
    ] = this.state.selectedFile;
    var result = convert.json2xml(dl, options);
    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState == 4) {
        if (xmlhttp.status == 200) {
          var res = convert.xml2json(xmlhttp.responseText, options);
        }
      }
    };
    // Send the POST request
    xmlhttp.setRequestHeader("Content-Type", "text/xml");

    if(localStorage.getItem("partnerId") != undefined && localStorage.getItem("partnerId") != null && localStorage.getItem("partnerId") != "" && localStorage.getItem("partnerId") == '004-das') {
      xmlhttp.setRequestHeader("customerNumber", "1338895");
      xmlhttp.setRequestHeader("customerLogin", "matycali");
      xmlhttp.setRequestHeader(
        "customerSignature",
        "jA0EAwMCtNh1kCqL30ZgySpqflbftlgjON%2FmMc9C8xQRDdXzDpzRFjWkwQiQjQ6otRBSntOfMlcBC8I%3D"
      );
      xmlhttp.setRequestHeader("interfacePartnerNumber", "1338895");
      xmlhttp.setRequestHeader(
        "interfacePartnerSignature",
        "eNfN45ytNZGuf%2Bx4h9E4"
      );
    }
    else {
      xmlhttp.setRequestHeader("customerNumber", "1333360");
      xmlhttp.setRequestHeader("customerLogin", "kasadhru");
      xmlhttp.setRequestHeader(
        "customerSignature",
        "9DC08C58C84722C5151DF153E8C598B844E53CCC479AFD9C4389AD367CADDBD7"
      );
      xmlhttp.setRequestHeader("interfacePartnerNumber", "1333360");
      xmlhttp.setRequestHeader(
        "interfacePartnerSignature",
        "9EE76520EAFCA3CBC61D1577BA1E8024A63792EE20FC15C27ABE45487F0DF4B9"
      );
    }
    
    xmlhttp.setRequestHeader("DAT-ProductVariant", "myclaim.pro");
    xmlhttp.send(result);
  };

  vinFolderList = async () => {
    const partnerId = localStorage.getItem("partnerId");
    if (partnerId) {
      const url = configuration.resultTxt;
      const response = await Axios.get(url + "?partnerId=" + partnerId);

      const vinAvg =
        response &&
        response.data &&
        response.data.result_data.length &&
        response.data.result_data.map((row) => {
          // const sum =
          //   row.resultTXT &&
          //   row.resultTXT.length &&
          //   row.resultTXT.scanresult &&
          //   row.resultTXT.scanresult.reduce(
          //     (prv, current, arr) => parseInt(prv) + parseInt(current.Amount),
          //     0
          //   );
          // const avg = sum / row.resultTXT.scanresult.length;
          // return { avg: "avg", vin: "", dents: "" };

          if (row.resultTXT && row.resultTXT.scanresult) {
            const sum = row.resultTXT.scanresult.reduce(
              (prv, current, arr) => parseInt(prv) + parseInt(current.Amount),
              0
            );
            const avg = sum / row.resultTXT.scanresult.length;
            return { avg: avg, vin: row.resultTXT.vin, dents: sum };
          } else {
            return {
              avg: "avg",
              vin: row.resultTXT ? row.resultTXT.vin : "",
              dents: "",
            };
          }
        });
      this.setState({ vinfolderList: vinAvg });
    } else {
      this.props.history.push("/login");
    }
  };

  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };
  showDummyData = () => {
    //this.getData(this.state.selectedFile);
    this.customerInfo();
  };
  save = async (e) => {
    e.preventDefault();
    const data = this.state.customerInfo;
    data.partnerId = localStorage.getItem("partnerId");
    data.vinNumber = localStorage.getItem("selectedFile");
    const url = configuration.PostCustomerInfo;
    await Axios.post(url, data).then((res) => {
      Toast.fire({
        type: "success",
        title: "Profile updated successfully",
      });
    });
    localStorage.setItem("userSession", JSON.stringify(data));
  };
  render() {
    const selectedFile = localStorage.getItem("selectedFile");
    const {
      manufacturer,
      customerNumber,
      emailAddress,
      Name,
      model,
      street,
      color,
      regNo,
      customerCity,
      postalCode,
    } = this.state.customerInfo;
    return (
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            <FormGroup row className="my-0">
              <Col md="3">
                <FormGroup>
                  {/* <Label>Vin</Label> */}
                  <Input
                    type="text"
                    id="city"
                    placeholder="Enter Vin"
                    value={selectedFile}
                  />
                </FormGroup>
              </Col>
              <Col md="3">
                <FormGroup>
                  {/* <Label>Select Vin</Label> */}
                  <select
                    className="form-control"
                    id="sel"
                    onChange={(e) => this.selectFile(e)}
                    value={this.state.selectedFile}
                  >
                    <option value="">Select VIN</option>
                    {this.state.vinfolderList &&
                      this.state.vinfolderList.length &&
                      this.state.vinfolderList.map((row, i) => (
                        <option key={i} value={row.vin}>
                          {row.vin} ({Math.round(row.dents)})
                        </option>
                      ))}
                  </select>
                </FormGroup>
              </Col>
              <Col md="2">
                <button
                  onClick={() => this.showDummyData()}
                  className="btn btn-danger btn-sm "
                  disabled={this.state.selectedFile ? false : true}
                >
                  <i className="fa fa-download"></i>Load Data
                </button>
              </Col>
              <Col md="2">
                <button
                  onClick={() => this.connectDAT()}
                  className="btn btn-success btn-sm "
                  //disabled={this.state.selectedFile ? false : true}
                >
                  <i className="fa fa-download"></i> Connect To Dat
                </button>
              </Col>
            </FormGroup>
          </div>
          {/* <div classNameName="card-body"> */}
          <Row>
            <Col md="12" sm="12">
              <Card>
                <CardHeader>
                  <strong>Customer</strong>
                  <small> Profile</small>
                </CardHeader>
                <CardBody>
                  {/* <FormGroup>
                  <Label htmlFor="company">Company</Label>
                  <Input type="text" id="company" placeholder="Enter your company name" />
                </FormGroup>
                <FormGroup>
                  <Label htmlFor="vat">Street and number</Label>
                  <Input type="text" id="vat" placeholder="DE1234567890" />
                </FormGroup>
                <FormGroup>
                  <Label htmlFor="street">Street</Label>
                  <Input type="text" id="street" placeholder="Enter street name" />
                </FormGroup> */}
                  <FormGroup row className="my-0">
                    <Col md="4">
                      <FormGroup>
                        <Label>Name</Label>
                        <Input
                          type="text"
                          id="city"
                          placeholder="Enter Full Name"
                          onChange={this.handleChange}
                          value={Name}
                          name="Name"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label htmlFor="postal-code">Street and nummer</Label>
                        <Input
                          type="text"
                          id="postal-code"
                          placeholder="Street and nummer"
                          onChange={this.handleChange}
                          value={street}
                          name="street"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="4">
                      <FormGroup>
                        <Label htmlFor="postal-code">Insurence Client</Label>
                        <select
                          className="form-control"
                          placeholder="Insurence client"
                          onChange={this.handleChange}
                          value={this.state.client}
                          name="client"
                        >
                          <option>--select--</option>
                          <option>AIG</option>
                        </select>
                      </FormGroup>
                    </Col>
                  </FormGroup>
                  <FormGroup row className="my-0">
                    <Col md="3">
                      <FormGroup>
                        <Label>Postal Code</Label>
                        <Input
                          type="text"
                          id="city"
                          placeholder="Postal Code"
                          onChange={this.handleChange}
                          value={postalCode}
                          name="postalCode"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <Label>Place</Label>
                        <Input
                          type="text"
                          id="city"
                          placeholder="Place"
                          onChange={this.handleChange}
                          value={customerCity}
                          name="customerCity"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <Label>Phone</Label>
                        <Input
                          type="text"
                          id="city"
                          placeholder="Phone"
                          onChange={this.handleChange}
                          value={customerNumber}
                          name="customerNumber"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <Label>Email Address</Label>
                        <Input
                          type="text"
                          id="city"
                          placeholder="Email Address"
                          onChange={this.handleChange}
                          value={emailAddress}
                          name="emailAddress"
                        />
                      </FormGroup>
                    </Col>
                  </FormGroup>
                  <FormGroup row className="my-0">
                    <Col md="3">
                      <FormGroup>
                        <Label>
                          Make : {this.state.customerInfo.manufacturer}
                        </Label>

                        <select
                          className="form-control"
                          placeholder="Make"
                          onChange={(e) => {
                            const Models = this.state.makeModel.filter((t) => {
                              return t.Make == e.target.value;
                            });
                            let cc = this.state.customerInfo;
                            cc.manufacturer = e.target.value;
                            this.setState({
                              ...cc,
                              Models: Models[0].Model,
                            });
                          }}
                          value={this.state.customerInfo.manufacturer}
                          name="manufacturer"
                        >
                          <option>-- Select--</option>
                          {this.state.makeModel.map((r) => (
                            <option>{r.Make}</option>
                          ))}
                        </select>
                        {/* <Input
                                         type="text"
                                         id="city"
                                         placeholder="Manufacturer"
                                         onChange={this.handleChange}
                                         value={manufacturer}
                                         name="manufacturer"
                                       /> */}
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <Label htmlFor="Model">Model</Label>

                        <select
                          className="form-control"
                          placeholder="Model"
                          onChange={this.handleChange}
                          value={this.state.customerInfo.model}
                          name="model"
                        >
                          <option>
                            {this.state.customerInfo.model || "--select--"}
                          </option>

                          {this.state.Models.length &&
                            this.state.Models.map((r) => <option>{r}</option>)}
                        </select>

                        {/* <Input
                                         type="text"
                                         id="Model"
                                         placeholder="Enter Car Model"
                                         onChange={this.handleChange}
                                         value={model}
                                         name="model"
                                       /> */}
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <Label>Color</Label>
                        <Input
                          type="text"
                          id="city"
                          placeholder="Enter your Car Color"
                          onChange={this.handleChange}
                          value={color}
                          name="color"
                        />
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <Label>Registration No </Label>
                        <Input
                          type="text"
                          id="city"
                          placeholder="Registration No"
                          onChange={this.handleChange}
                          value={regNo}
                          name="regNo"
                        />
                      </FormGroup>
                    </Col>
                  </FormGroup>
                </CardBody>

                <div className="card-footer">
                  <button className="btn btn-danger btn-sm" onClick={this.save}>
                    Update Profile
                  </button>

                  <Link className="glass" to="/order">
                    <button
                      className="btn btn-danger btn-sm pull-right"
                      style={{ marginRight: 10 }}
                    >
                      <i className="fa fa-dot-circle-o"></i> {">>"}
                    </button>
                  </Link>

                  <Link className="glass" to="/dashboard">
                    <button
                      className="btn btn-danger btn-sm pull-right"
                      style={{ marginRight: 10 }}
                    >
                      {"<<"} <i className="fa fa-dot-circle-o"></i>
                    </button>
                  </Link>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

//export default Colors;
